/* global google */
window.initMap = function () {
  const directionsService = new google.maps.DirectionsService;
  const directionsDisplay = new google.maps.DirectionsRenderer;

  const map = new google.maps.Map(document.getElementById('map'), {
    center: {lat: 40.3977709, lng: -101.5592899},
    zoom: 4,
    mapTypeControl: false,
  });

  const input = document.getElementById('search');
  const options = {
    fields: ['formatted_address', 'geometry', 'name'],
    strictBounds: false,
  };

  map.data.loadGeoJson('/assets/js/list.json', {idPropertyName: 'fasid'});
  
  const apiKey = 'AIzaSyCDyQihFxpmQQC2uNlfQUpjaqVCceki6-8';
  const infoWindow = new google.maps.InfoWindow(apiKey);

  navigator.geolocation.getCurrentPosition(async (position) => {
    setTimeout(function () {
      setStartLocation(position.coords.latitude, position.coords.longitude, 13);

    }, 2000);
  }, () => {
    fetch('/assets/js/list.json')
      .then((res) => {
        if (!res.ok) {
          throw new Error
          (`HTTP error! Status: ${res.status}`);
        }  
        return res.json();
      })
      .then((data) =>
        storesList(data.features));
  });

  const setStartLocation = async(lat, lng, zoom) => {
    var pos = {
      lat: lat,
      lng: lng
    }; 
    var originLocation = new google.maps.LatLng(lat, lng);

    infoWindow.setPosition(pos);
    map.setCenter(pos);
    map.setZoom(zoom);

    originMarker.setPosition(originLocation);
    originMarker.setVisible(true);

    window.pos = pos; 

    const rankedStores = await calculateDistances(map.data, originLocation);
    showStoresList(map.data, rankedStores, directionsService, directionsDisplay);
  };

  map.data.addListener('click', (event) => {
    const name = event.feature.getProperty('name');
    const address = event.feature.getProperty('address') + '<br />' + event.feature.getProperty('city') + ' ' + event.feature.getProperty('state') + ' ' + event.feature.getProperty('zip');
    const phone = event.feature.getProperty('phone');
    const fax = event.feature.getProperty('fax');
    const url = event.feature.getProperty('url');
    const email = event.feature.getProperty('email');
    const urlTitle = event.feature.getProperty('urlTitle');
    const position = event.feature.getGeometry().get();
    const content = `<div>
      <h4>${name}</h4>
      <p>${address}</p>
      ${phone ? '<p>P: '+phone+'</p>' : ''}
      ${fax ? '<p>F: '+fax+'</p>' : ''}
      ${email ? '<p><a href="mailto:'+email+'" target="_blank">'+email+'</a></p>' : ''}
      ${url ? '<p><a href="'+url+'" target="_blank">'+(urlTitle || url)+'</a></p>' : ''}
    </div>`;

    infoWindow.setContent(content);
    infoWindow.setPosition(position);
    infoWindow.setOptions({pixelOffset: new google.maps.Size(0, -30)});
    infoWindow.open(map);
  });

  directionsDisplay.setMap(map);
  directionsDisplay.setPanel(document.getElementById('sidebar'));

  const autocomplete = new google.maps.places.Autocomplete(input, options);
  autocomplete.bindTo('bounds', map);

  const originMarker = new google.maps.Marker({map: map});
  originMarker.setVisible(false);
  let originLocation = map.getCenter();

  autocomplete.addListener('place_changed', async () => {
    if (document.getElementById('overlay'))
      document.getElementById('overlay').remove();
    document.getElementById('sidebar').classList.remove('open');
    directionsDisplay.setDirections({routes: []});
    originMarker.setVisible(false);
    originLocation = map.getCenter();
    const place = autocomplete.getPlace();

    if (!place.geometry) {
      window.alert('No address available for input: \'' + place.name + '\'');
      return;
    }

    originLocation = place.geometry.location;
    window.pos = {lat: originLocation.lat(), lng: originLocation.lng() }; 
    map.setCenter(originLocation);
    map.setZoom(9);

    originMarker.setPosition(originLocation);
    originMarker.setVisible(true);

    const rankedStores = await calculateDistances(map.data, originLocation);
    showStoresList(map.data, rankedStores, directionsService, directionsDisplay);

    return;
  });
};

const calculateDistances = async (data, origin) => {
  const list = [];
  const destinations = [];

  data.forEach((item) => {
    const id = item.getProperty('fasid');
    const loc = item.getGeometry().get();

    list.push(id);
    destinations.push(loc);
  });


  const service = new google.maps.DistanceMatrixService();
  const getDistanceMatrix =
    (service, parameters) => new Promise((resolve, reject) => {
      service.getDistanceMatrix(parameters, (response, status) => {
        if (status != google.maps.DistanceMatrixStatus.OK) {
          reject(response);
        } else {
          const distances = [];
          const results = response.rows[0].elements;
          console.log(results);
          for (let j = 0; j < results.length; j++) {
            const element = results[j];
            const distanceText = element.distance.text;
            const distanceVal = element.distance.value;
            const distanceObject = {
              fasid: list[j],
              distanceText: distanceText,
              distanceVal: distanceVal,
            };
            distances.push(distanceObject);
          }

          resolve(distances);
        }
      });
    });

    function haversineDistance(coord1, coord2) {
      const R = 3958.8; // Earth's radius in miles
      const toRadians = degrees => degrees * Math.PI / 180;
      const lat1 = toRadians(coord1[0]);
      const lon1 = toRadians(coord1[1]);
      const lat2 = toRadians(coord2[0]);
      const lon2 = toRadians(coord2[1]);
      const dLat = lat2 - lat1;
      const dLon = lon2 - lon1;
      const a = Math.sin(dLat / 2) ** 2 +
                Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c;
      return distance;
  }

  let distancesList = [];

  destinations.forEach((destinationItem, i) => {
    const distance = haversineDistance([window.pos.lat, window.pos.lng], [destinationItem.lat(), destinationItem.lng()]);

    distancesList.push({
      fasid: list[i],
      distanceText: `${parseInt(distance)} mi`,
      distanceVal: distance
    })
  });

  // const distancesList = await getDistanceMatrix(service, {
  //   origins: [origin],
  //   destinations: destinations,
  //   travelMode: 'DRIVING',
  //   unitSystem: google.maps.UnitSystem.IMPERIAL,
  // });

  distancesList.sort((first, second) => {
    return first.distanceVal - second.distanceVal;
  });

  console.log(distancesList);

  return distancesList;
};

const showStoresList = (data, stores, directionsService, directionsDisplay) => {
  if (stores.length == 0) {
    console.log('empty results');
    return;
  }

  let panel = document.getElementById('panel');
  if (panel.classList.contains('open')) {
    panel.classList.remove('open');
  }

  while (panel.lastChild) {
    panel.removeChild(panel.lastChild);
  }

  stores.forEach((store) => {
    const el = document.createElement('div');
    const info = document.createElement('div');
    const name = document.createElement('h4'); 
    const details = document.createElement('p');
    name.classList.add('place');
    const currentStore = data.getFeatureById(store.fasid);
    name.innerHTML = currentStore.getProperty('name');
    info.appendChild(name);
    details.innerHTML = `${currentStore.getProperty('address')}<br />
    ${currentStore.getProperty('city')}, ${currentStore.getProperty('state')} ${currentStore.getProperty('zip')}<br />
    ${currentStore.getProperty('phone') ? 'P: '+currentStore.getProperty('phone')+'<br />' : ''}
    ${currentStore.getProperty('fax') ? 'F: '+currentStore.getProperty('fax')+'<br />' : ''}
    ${currentStore.getProperty('email') ? '<a href="mailto:'+currentStore.getProperty('email')+'" target="_blank">'+currentStore.getProperty('email')+'</a><br />' : ''}
    ${currentStore.getProperty('url') ? '<a href="'+currentStore.getProperty('url')+'" target="_blank">'+(currentStore.getProperty('urlTitle') || currentStore.getProperty('url'))+'</a>' : ''}
    `;
    info.appendChild(details);
    const btn = document.createElement('button');
    btn.innerText = 'Directions';
    btn.addEventListener('click', function() {
      const loc = currentStore.getGeometry().get();
      calculateAndDisplayRoute(loc, directionsService, directionsDisplay);
    });
    info.appendChild(btn);

    const distanceText = document.createElement('p');
    distanceText.classList.add('distanceText');
    distanceText.textContent = store.distanceText;
    el.appendChild(distanceText);
    el.appendChild(info);
    panel.appendChild(el);
  });

  panel.classList.add('open');

  return;
};

const calculateAndDisplayRoute = (storeLoc, directionsService, directionsDisplay) => {
  directionsService.route({
    origin: new google.maps.LatLng(window.pos.lat, window.pos.lng),
    destination: new google.maps.LatLng(storeLoc.lat(), storeLoc.lng()),
    travelMode: 'DRIVING'
  }, function(response, status) {
    if (status === 'OK') {
      directionsDisplay.setDirections(response);
      document.getElementById('sidebar').classList.add('open');
    } else
      window.alert('Directions request failed due to ' + status);
  });
};

const storesList = (stores) => {
  let panel = document.getElementById('panel');

  stores.forEach(store => {
    const el = document.createElement('div');
    const info = document.createElement('div');
    const name = document.createElement('h4'); 
    const details = document.createElement('p');
    name.classList.add('place');
    name.innerHTML = store.properties.name;
    info.appendChild(name);
    details.innerHTML = `${store.properties.address}<br />
    ${store.properties.city}, ${store.properties.state} ${store.properties.zip}<br />
    ${store.properties.phone ? 'P: '+store.properties.phone+'<br />' : ''}
    ${store.properties.fax ? 'F: '+store.properties.fax+'<br />' : ''}
    ${store.properties.email ? '<a href="mailto:'+store.properties.email+'" target="_blank">'+store.properties.email+'</a><br />' : ''}
    ${store.properties.url ? '<a href="'+store.properties.url+'" target="_blank">'+(store.properties.urlTitle || store.properties.url)+'</a>' : ''}
    `;
    info.appendChild(details);

    const distanceText = document.createElement('p');
    el.appendChild(distanceText);
    el.appendChild(info);
    panel.appendChild(el);
  });

  panel.classList.add('open');
};